import React from "react";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import RAGIndicator from "components/visuals/RAGIndicator";

import { selectors } from "modules/customer/insights/portfolio/catchment/demographicBreakdown";

const RepresentationOfBestDemographics = () => {
    const representationOfBestDemographics = useSelector(state => selectors.representationOfBestDemographics(state));
    const { loading, error, id, label, status, value } = representationOfBestDemographics;

    return (
        <Box data-cy={id}>
            <RAGIndicator loading={loading} error={error} label={label} status={status} value={value} />
        </Box>
    );
};

export default RepresentationOfBestDemographics;
